import React from 'react';
import { Container } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import HeaderContainer from '../../containers/HeaderContainer';

import styles from './Fixed.module.scss';

const Fixed = ({ menuDesktopActived }) => (
  <div
    className={`${styles.wrapper} ${
      menuDesktopActived ? styles.sidebar_full : styles.sidebar_mini
    }`}
  >
    <Container fluid>
      <HeaderContainer />
    </Container>
  </div>
);

Fixed.propTypes = {
  menuDesktopActived: PropTypes.bool,
};

Fixed.defaultProps = {
  menuDesktopActived: true,
};

export default Fixed;
